export default __webpack_public_path__ + "static/media/cyclades.3aad72cf.jpg";